module.exports = __webpack_public_path__ + "media/images/ic-caixa-menu-11c08eee55d7f9163ad43a81b133d530.svg";